/* FAQS */
export const GET_FAQS = "GET_FAQS";
export const GET_FAQS_SUCCESS = "GET_FAQS_SUCCESS";
export const GET_FAQS_FAIL = "GET_FAQS_FAIL";

export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";

export const ADD_NEW_FAQ = "ADD_NEW_FAQ";
export const ADD_FAQ_SUCCESS = "ADD_FAQ_SUCCESS";
export const ADD_FAQ_FAIL = "ADD_FAQ_FAIL";

export const UPDATE_FAQ = "UPDATE_FAQ";
export const UPDATE_FAQ_SUCCESS = "UPDATE_FAQ_SUCCESS";
export const UPDATE_FAQ_FAIL = "UPDATE_FAQ_FAIL";

export const DELETE_FAQ = "DELETE_FAQ";
export const DELETE_FAQ_SUCCESS = "DELETE_FAQ_SUCCESS";
export const DELETE_FAQ_FAIL = "DELETE_FAQ_FAIL";

export const MODIFY_FAQ_FLAG = "MODIFY_FAQ_FLAG";

export const RESET_FAQ_FLAG = "RESET_FAQ_FLAG";

export const GET_FAQ_DETAILS = "GET_FAQ_DETAILS";
export const GET_FAQ_DETAILS_SUCCESS = "GET_FAQ_DETAILS_SUCCESS";
export const GET_FAQ_DETAILS_FAIL = "GET_FAQ_DETAILS_FAIL";

// STATUS CHANGE
export const STATUS_CHANGE_FAQ = "STATUS_CHANGE_FAQ";
export const STATUS_CHANGE_FAQ_SUCCESS = "STATUS_CHANGE_FAQ_SUCCESS";
export const STATUS_CHANGE_FAQ_FAIL = "STATUS_CHANGE_FAQ_FAIL";

// FEATURED CHANGE
export const FEATURED_CHANGE_FAQ = "FEATURED_CHANGE_FAQ";
export const FEATURED_CHANGE_FAQ_SUCCESS = "FEATURED_CHANGE_FAQ_SUCCESS";
export const FEATURED_CHANGE_FAQ_FAIL = "FEATURED_CHANGE_FAQ_FAIL";

// Save Ordering
export const SAVE_ORDERING_FAQ = "SAVE_ORDERING_FAQ";
export const SAVE_ORDERING_FAQ_SUCCESS = "SAVE_ORDERING_FAQ_SUCCESS";
export const SAVE_ORDERING_FAQ_FAIL = "SAVE_ORDERING_FAQ_FAIL";
export const SAVE_ORDERING_FAQ_RESET_FLAG = "SAVE_ORDERING_FAQ_RESET_FLAG";
